const prefix = 'requery/';

export default {
    REQUEST_START: prefix + 'REQUEST_START',
    REQUEST_SUCCESS: prefix + 'REQUEST_SUCCESS',
    REQUEST_FAILURE: prefix + 'REQUEST_FAILURE'
};



/** WEBPACK FOOTER **
 ** ../src/dash/front/requery/actionTypes.js
 **/